var _rect, _circle, _path, _circle2, _circle3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWikiMenuCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.66663,
    y: 11.6666,
    width: 26.6667,
    height: 20,
    rx: 2.5,
    fill: "#D1CFCD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.75,
    cy: 16.25,
    r: 2.08333,
    fill: "#FF791C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11.6667C12.5 9.82576 13.9924 8.33337 15.8333 8.33337H24.1667C26.0076 8.33337 27.5 9.82576 27.5 11.6667H12.5Z",
    fill: "#5C5B5A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 22.5,
    r: 5.83333,
    fill: "#ECECEC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1451_18212",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 16,
    width: 12,
    height: 13
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 22.5,
    r: 5.83333,
    fill: "#ECECEC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1451_18212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5833 30.8333L9.16663 10V30.8333H29.5833Z",
    fill: "#E2E2E2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWikiMenuCamera);
export default __webpack_public_path__ + "static/media/wikiMenuCamera.f1263e96f9f0b610f2139acf4a449bdc.svg";
export { ForwardRef as ReactComponent };